import ModularHeaderContainer from './ModularHeaderContainer';

export default ModularHeaderContainer;
